module.exports = __webpack_public_path__ + "img/car_00015.d99c431f.jpg";